/* Copyright (c) 2020 Lenderblock Corporation */

let blenderPrivateKey = 'ribbon animal horn asthma case enough rival calm meadow armor flag photo'
export default blenderPrivateKey; 